export function statusSlug(s) {
  if (s == null) return s
  return typeof s === 'object' && s.slug != null ? s.slug : s
}

export function statusName(s) {
  if (s == null) return ''
  return typeof s === 'object' && s.name != null ? s.name : ''
}

export function statusColor(s) {
  if (s == null || !s.color) return null
  return typeof s.color === 'string' ? s.color.trim() : null
}

export function isStatusObject(s) {
  return typeof s === 'object' && s != null && 'slug' in s
}

export function statusIsShown(s) {
  if (s == null || typeof s !== 'object') return true
  return s.is_shown !== false
}

function normalizeStatusForMatch(s) {
  if (s == null || typeof s !== 'string') return ''
  return String(s).trim().toLowerCase().replace(/\s+/g, '_')
}

export function statusToTranslationKey(s) {
  return normalizeStatusForMatch(s)
}

export function taskStatusMatchesBoard(taskStatus, board) {
  if (taskStatus == null) return false
  const boardId = typeof board === 'object' && board != null && board.id != null ? Number(board.id) : null
  const taskId = typeof taskStatus === 'number' ? taskStatus : (typeof taskStatus === 'string' && taskStatus.trim() !== '' && !Number.isNaN(Number(taskStatus)) ? Number(taskStatus) : null)
  if (boardId != null && taskId != null) return boardId === taskId
  const slug = statusSlug(board)
  const name = statusName(board)
  const t = String(taskStatus).trim()
  const tNorm = normalizeStatusForMatch(taskStatus)
  const slugStr = slug != null ? String(slug) : ''
  const slugNorm = slugStr ? slugStr.toLowerCase() : ''
  return t === slug || (slugNorm && tNorm === slugNorm) ||
    (name && t === name) || (name && t.toLowerCase() === name.toLowerCase())
}

export function boardsToSlugs(boards) {
  if (!Array.isArray(boards)) return []
  return boards.map(statusSlug).filter(Boolean)
}

export function boardsToNames(boards) {
  if (!Array.isArray(boards)) return []
  return boards.map(b => statusName(b) || statusSlug(b) || '').filter(Boolean)
}

export function boardsToIds(boards) {
  if (!Array.isArray(boards)) return []
  return boards
    .map((b) => (typeof b === 'object' && b != null && b.id != null ? Number(b.id) : null))
    .filter((id) => id != null && !Number.isNaN(id))
}

export function resolveProjectBoards(projectStatuses, allStatusesFromApi) {
  if (!Array.isArray(projectStatuses)) projectStatuses = []
  if (!Array.isArray(allStatusesFromApi) || !allStatusesFromApi.length) {
    return projectStatuses.length && projectStatuses.every(isStatusObject)
      ? [...projectStatuses]
      : projectStatuses
  }
  if (projectStatuses.length && isStatusObject(projectStatuses[0])) {
    return [...projectStatuses]
  }
  if (!projectStatuses.length) {
    return [...allStatusesFromApi].sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
  }
  return projectStatuses
    .map((val) => {
      const slugVal = typeof val === 'string' ? val : (val?.slug ?? '')
      const bySlug = allStatusesFromApi.find((s) => String(s.slug || '').toLowerCase() === String(slugVal).toLowerCase())
      if (bySlug) return bySlug
      const byId = typeof val === 'number' ? allStatusesFromApi.find((s) => s.id === val) : null
      return byId || null
    })
    .filter(Boolean)
}
